import { render, staticRenderFns } from "./TasksSingle.vue?vue&type=template&id=0ec3ef9e"
import script from "./TasksSingle.vue?vue&type=script&lang=js"
export * from "./TasksSingle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../website-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports